import Repository, { DefaultLimit } from '@infinity/shared/repos/base'
import { Api } from '@infinity/shared/helpers/api'
import { Filter, FilterCollection, FilterOperand } from '@infinity/shared/helpers/filter'
import FixedNumber from '@/models/FixedNumber'
import axios from 'axios'

export default class FixedNumberRepo extends Repository {
  constructor (installationId: number) {
    super(Api.Hub, `config/igrps/${installationId}/dgrps/all/numbers/fixed`, FixedNumber, 'numbers')
  }

  async getFixedNumberIds (installationTimeZone: string): Promise<number[]> {
    const filters = new FilterCollection(new Filter('ch', FilterOperand.NotEquals, 0))

    const response = await axios.get(`${this.api}/${this.apiRoute}`, {
      params: { filters: filters.toApi(), tz: installationTimeZone },
      ...this.requestConfig
    })

    const data = []
    if (response && response.data) {
      const items = response.data.numbers

      if (items) {
        for (const item of items) {
          data.push(parseInt(item.phoneId))
        }
      }
    }

    return data
  }

  async getFixedNumbers (filter: string | null, offset: number, installationTimeZone: string): Promise<FixedNumber[] | null> {
    const filters = new FilterCollection(new Filter('ch', FilterOperand.NotEquals, 0))

    if (filter && filter !== '') {
      filters.addFilter(new Filter('usageFilter', FilterOperand.IncludesI, filter))
    }

    const response = await axios.get(`${this.api}/${this.apiRoute}`, {
      params: { filters: filters.toApi(), limit: DefaultLimit, offset: offset, tz: installationTimeZone },
      ...this.requestConfig
    })

    const data = []
    if (response && response.data) {
      const items = response.data.numbers

      if (items) {
        for (const item of items) {
          data.push(
            new this.Model().fromApiTransformer(item, this.api)
          )
        }
      }
    }

    if (Array.isArray(data)) {
      data.forEach((model) => {
        if (!(model instanceof FixedNumber)) {
          return null
        }
      })

      return data as FixedNumber[]
    }

    return null
  }
}
